import { CustomerResultAddress } from 'type/address';
import { PersonNameList } from 'type/household';
import { CustomerResultItem } from '../customerResult/CustomerResultItem';

interface HouseholdProps {
  'data-testid'?: string;
  personList?: PersonNameList[];
  address?: CustomerResultAddress;
  onClick: () => void;
}

export const Household = ({
  'data-testid': testId = 'select-household',
  personList,
  onClick,
  address,
}: HouseholdProps) => {
  if (!Array.isArray(personList) || !personList.length) {
    return null;
  }

  const [person, ...additionalPersons] = [...personList].sort(
    (firstPerson, secondPerson) => firstPerson.order - secondPerson.order,
  );

  return (
    <CustomerResultItem
      additionalPersons={additionalPersons}
      address={address}
      onClick={onClick}
      person={person}
      testId={testId}
    />
  );
};
